const qty = new Intl.NumberFormat('en', { maximumFractionDigits: 3 });

export const formatQty = (n: number | null | undefined) => (n === null || n === undefined ? '' : qty.format(n));

/** Set from /me after sign-in; dates render in this zone (default Asia/Riyadh) */
let currentTimezone = 'Asia/Riyadh';
export function setTimezone(tz: string | null | undefined) {
  if (tz) currentTimezone = tz;
}
export const getTimezone = () => currentTimezone;

/** Set from /me after sign-in. The API already returns amounts in this currency. */
let currentCurrency = 'SAR';
export function setCurrency(c: string | null | undefined) {
  if (c) currentCurrency = c;
}
export const getCurrency = () => currentCurrency;

const CURRENCY_DISPLAY: Record<string, string> = { SAR: 'SAR', CNY: 'RMB' };
export const currencyName = (c: string = currentCurrency) => CURRENCY_DISPLAY[c] ?? c;

export function formatMoney(n: number | null | undefined, currency?: string | null) {
  if (n === null || n === undefined) return '';
  const amount = new Intl.NumberFormat('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
  return `${currencyName(currency ?? currentCurrency)} ${amount}`;
}

export function formatDateTime(iso: string | null | undefined) {
  if (!iso) return '';
  return new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium', timeStyle: 'short', timeZone: currentTimezone }).format(new Date(iso));
}

/** The calendar day (YYYY-MM-DD) an instant falls on in the application time zone */
export function dayInAppZone(iso: string) {
  return new Intl.DateTimeFormat('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: currentTimezone }).format(new Date(iso));
}

export function formatDate(iso: string | null | undefined) {
  if (!iso) return '';
  // date-only values (YYYY-MM-DD) are calendar dates, not instants
  const d = /^\d{4}-\d{2}-\d{2}$/.test(iso) ? new Date(`${iso}T12:00:00Z`) : new Date(iso);
  return new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium', timeZone: /^\d{4}-\d{2}-\d{2}$/.test(iso) ? 'UTC' : currentTimezone }).format(d);
}

export function formatMonth(isoFirstDay: string) {
  return new Intl.DateTimeFormat('en-GB', { month: 'long', year: 'numeric', timeZone: 'UTC' }).format(new Date(`${isoFirstDay}T12:00:00Z`));
}

export function formatRelative(iso: string | null | undefined) {
  if (!iso) return 'Never';
  const diff = Date.now() - new Date(iso).getTime();
  const min = Math.round(diff / 60000);
  if (min < 1) return 'Just now';
  if (min < 60) return `${min} min ago`;
  const h = Math.round(min / 60);
  if (h < 24) return `${h} h ago`;
  const d = Math.round(h / 24);
  if (d < 30) return `${d} day${d === 1 ? '' : 's'} ago`;
  return formatDateTime(iso);
}
